import React from 'react';

const TrendsWideTable = ({ content }) => {
  const [titleLeft, titleRight] = content.title;

  return (
    <section style={{ backgroundColor: '#F4F4F6'}} className="p-4 p-sm-5 mb-4">
      <h2 className="mb-4 mt-3">
        {titleLeft}
        <span style={{
            background: 'linear-gradient(90deg, #6e25dd 0%, #A014FD 10%, #3AE1F9 96.15%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
          }}>
          {titleRight}
        </span>
      </h2>

      <div className="border-top border-5 mb-4" style={{ borderImageSlice:1, borderImageSource: 'linear-gradient(90deg, #43128E 0%, #A014FD 50%, #3AE1F9 96.15%)',}} />

      <div className="space-y-6">
        {content.rows.map(([left, right], idx) => (
          <div
            key={idx}
            className={`row gx-4 ${idx !== content.rows.length -1 ? "border-bottom border-1 pb-3 mb-3" : ""}`}
          >
            <div
              className="col col-9 text-gray-900 lh-lg text-sm"
              dangerouslySetInnerHTML={{ __html: left }}
            />
            <p className="col col-3 text-xs m-auto fw-light text-gray-900">
              <em>{right}</em>
            </p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default TrendsWideTable;